<div
  class="accordion-item-header"
  [class.accordion-item-header-menu]="styling === 'menu'"
  [class.accordion-bottom-radius]="!expanded"
  (click)="toggle()"
  (keydown.enter)="toggle()"
  role="button"
  tabindex="0"
  [id]="'accordion-header-' + id"
  [attr.aria-expanded]="expanded"
  [attr.aria-controls]="'accordion-body-' + id"
  @expandAnimations
>
  <ng-content select="[ssAccordionItemTitle]"></ng-content>
  <div class="expand-button">
    <svg
      [@rotate]="expanded ? '1' : '0'"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="white"
      class="w-6 h-6"
      aria-label="down arrow"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  </div>
</div>
<div
  class="accordion-item-body-wrapper"
  role="region"
  [attr.id]="'accordion-body-' + id"
  [attr.aria-labelledby]="'accordion-header-' + id"
  [@slideUpDown]="expanded ? '1' : '0'"
>
  <ng-content></ng-content>
</div>
<ng-content select="[ssAccordionItemDivider]"></ng-content>
